import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { lazy } from 'react';
import EditProduct from './edit-master-product/edit-products';
import EditProductVariant from './edit-product-variant/edit-products';
import EditStockCount from './tabs/edit-stock-count';
import { PageTitle } from '../../../umart_admin/layout/core';

const Products = lazy(() => import('./products'));
const AddNewProduct = lazy(() => import('./add-new-product'));
const AllProducts = lazy(() => import('./all-products'));
const ProductDetails = lazy(() => import('./product-details'));
const Index = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
        <Route
          index
          element={
            <>
              <PageTitle
                showHeading
                breadcrumbs={[
                  {
                    title: '',
                    path: '',
                    isSeparator: true,
                    isActive: false,
                  },
                ]}
              >
                All Products
              </PageTitle>
              <AllProducts />
            </>
          }
        />
        <Route
          path="/add-new-product"
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: '',
                    path: '',
                    isSeparator: true,
                    isActive: false,
                  },
                  {
                    title: 'All Products',
                    path: '/all-products',
                    isSeparator: false,
                    isActive: false,
                  },
                  {
                    title: '',
                    path: '',
                    isSeparator: true,
                    isActive: false,
                  },
                ]}
              >
                Add New Product
              </PageTitle>
              <AddNewProduct />
            </>
          }
        />
        <Route
          path="/view-all-products"
          element={
            <>
              <PageTitle
                showHeading
                breadcrumbs={[
                  {
                    title: '',
                    path: '',
                    isSeparator: true,
                    isActive: false,
                  },
                ]}
              >
                All Products
              </PageTitle>
              <AllProducts />
            </>
          }
        />
        <Route
          path="/product-details"
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: '',
                    path: '',
                    isSeparator: true,
                    isActive: false,
                  },
                  {
                    title: 'All Products',
                    path: '/all-products',
                    isSeparator: false,
                    isActive: false,
                  },
                  {
                    title: '',
                    path: '',
                    isSeparator: true,
                    isActive: false,
                  },
                ]}
              >
                Product Details
              </PageTitle>
              <ProductDetails />
            </>
          }
        />
      </Route>
      <Route
        path="/edit-product"
        element={
          <>
            <PageTitle
              breadcrumbs={[
                {
                  title: 'All Products',
                  path: '/all-products',
                  isSeparator: false,
                  isActive: false,
                },
              ]}
            >
              Edit Product
            </PageTitle>
            <EditProduct />
          </>
        }
      ></Route>
      <Route
        path="/edit-product-variant"
        element={
          <>
            <PageTitle
              breadcrumbs={[
                {
                  title: 'All Products',
                  path: '/all-products',
                  isSeparator: false,
                  isActive: false,
                },
              ]}
            >
              Edit Product Variant
            </PageTitle>
            <EditProductVariant />
          </>
        }
      ></Route>
      <Route
        path="/edit-stock-count"
        element={
          <>
            <PageTitle
              breadcrumbs={[
                {
                  title: 'Dashboard',
                  path: '/dashboard',
                  isSeparator: false,
                  isActive: false,
                },
                {
                  title: '',
                  path: '',
                  isSeparator: true,
                  isActive: false,
                },
                {
                  title: 'All Products',
                  path: '/all-products',
                  isSeparator: false,
                  isActive: false,
                },
                {
                  title: '',
                  path: '',
                  isSeparator: true,
                  isActive: false,
                },
              ]}
            >
              Edit Stock Count
            </PageTitle>
            <EditStockCount />
          </>
        }
      ></Route>
    </Routes>
  );
};
export default Index;
